import { ItemsContainerWebglSettingsConverter } from "./items-container-webgl-settings-converter";

export class TableWebglSettingsConverter extends ItemsContainerWebglSettingsConverter {
  constructor(viewObjectConverters) {
    super(viewObjectConverters);
  }

  convert(settings) {
    let settingsCopy = settings.copy();
    if (settingsCopy.items === undefined || this.viewObjectConverters === undefined || this.viewObjectConverters.size == 0) {
      return settingsCopy;
    }
    settingsCopy.items = [];
    for (let rowIndex = 0; rowIndex < settings.items.length; rowIndex++) {
      let rowItems = settings.items[rowIndex];
      let rowItemsCopies = [];
      for (let columnIndex = 0; columnIndex < rowItems.length; columnIndex++) {
        let convertedItemSettings = this._copyItem(rowItems[columnIndex]);
        if (convertedItemSettings !== undefined) {
          rowItemsCopies.push(convertedItemSettings);
        }
      }
      settingsCopy.items.push(rowItemsCopies);
    }
    return settingsCopy;
  }
}
